class Experience {
  constructor(job_title, employer, employerURL, start, end, city, description, bullets, technologies) {
    this.job_title = job_title;
    this.employer = employer;
    this.employerURL = employerURL;
    this.start = start;
    this.end = end;
    this.city = city;
    this.description = description;
    this.bullets = bullets;
    this.technologies = technologies;
  }

  setUpdatedAt(value) {
    this.updated_at = value;
  }

  static converter = {
    toDocument(experience) {
      return {
        job_title: experience.job_title,
        employer: experience.employer,
        employerURL: experience.employerURL,
        start: experience.start,
        end: experience.end,
        city: experience.city,
        description: experience.description,
        bullets: experience.bullets,
        technologies: experience.technologies,
        updated_at: experience.updated_at
      };
    },

    fromDocument(snapshot, options) {
      const data = snapshot.data(options);
      return new Experience(data.job_title, data.employer, data.employerURL, data.start, data.end, data.city, data.description, data.bullets, data.technologies, data.timestamp);
    }
  }

  toString() {
    var str = "Experience => ";
    Object.keys(this).forEach(prop => {
      str += `${prop}: "${this[prop]}", `;
    });
    return str;
  }
}

export default Experience;